import {restoreRepresentative} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";

import {representativeKeys, representativeMutationKeys} from "../../../representative-keys";

export function restoreRepresentativeMutationOptions() {
  return mutationOptions({
    mutationFn: (id: string) => restoreRepresentative(id),
    mutationKey: representativeMutationKeys.restoreRepresentative,
    onSuccess: async (_result, id, _context, {client}) => {
      client.removeQueries({queryKey: representativeKeys.detail(id)});
      await client.invalidateQueries({queryKey: representativeKeys.lists()});
    },
  });
}
